var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-message-container",style:({ height: _vm.height })},[_c('div',{staticClass:"no-data-message",style:({ fontSize: _vm.fontSize })},[_vm._v("No data available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }